import React, {forwardRef, useEffect, useState} from 'react';
import { Card, Table, Badge, Dropdown, Pagination } from 'react-bootstrap';
import {authService} from "../../services/authService";
import NotificationService from "../../services/NotificationService";
import {userService} from "../../services/userService";
import {businessYearService} from "../../services/businessYearService";
import eventEmitter from "../../shared/eventEmitter";
import {EventEmitterTypes} from "../../shared/eventEmitterEnum";
import {useNavigate} from "react-router-dom";
import PricePerSqFtModal from "./modals/PricePerSqFtModal";
import {CustomToggle} from "../../shared/components/CustomYearlySettingsToggleOptions";
import ConfirmationModal from "../ConfirmationModal";




export interface Settings {
    created: Date,
    current: boolean,
    maximumWorkAmountPerDay: number,
    scheduleEndDate: Date,
    scheduleStartDate: Date,
    year: number
}

interface YearlySettingsDetailsProps {
    details: Settings;
}

interface PriceBracket {
    priceBracketId: number;
    propertyType: string;
    minimumSquareFeet: number;
    maximumSquareFeet: number;
    fixedPrice: number;
    pricePerSquareFoot: number;

}




const PricePerSqFtCard: React.FC<YearlySettingsDetailsProps> = ({details}) => {
    const [priceBrackets, setPriceBracket] = useState<PriceBracket[]>([]);
    const [activeModalData, setActiveModalData] = useState<PriceBracket>();
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteRecordData, setDeleteRecordData] = useState(null);

    useEffect(() => {
        businessYearService.getPriceBrackets(details.year).then(res => {
            setPriceBracket(res);
        });
    }, []);

    useEffect(() => {
        const refreshListener = () => {
            businessYearService.getPriceBrackets(details.year).then(res => {
                setPriceBracket(res);
            });
        };

        eventEmitter.on(EventEmitterTypes.REFRESH_LOADED_YEAR_PRICE_BRACKET, refreshListener);

        return () => {
            eventEmitter.off(EventEmitterTypes.REFRESH_LOADED_YEAR_PRICE_BRACKET, refreshListener);
        };
    }, []);

    const deleteRecord = () => {
        businessYearService.deletePriceBracket(details.year, deleteRecordData).then(r => eventEmitter.emit(EventEmitterTypes.REFRESH_LOADED_YEAR_PRICE_BRACKET));
    }
    return (
    <>
        <div className="card yearlySettingsCard">
            <div className="cardHeader">
                <h2 className="">
                                    <span className="cuteIcon green">
                                        <i className="fa-solid fa-dollar"></i>
                                    </span>
                    Price per Sq Ft
                </h2>
                <div className="cardAction">
                    <button type="button" className="btn btn-settings" data-bs-toggle="modal"
                            data-bs-target="#priceSqFtModal" onClick={() => {
                                setShowModal(true);
                                setActiveModalData(null);
                    }}>
                        <i className="fa-regular fa-plus"></i> add
                    </button>
                </div>
            </div>
            <div className="cardTable">
                <table className="table table-sm table-hover align-middle">
                    <thead>
                    <tr>
                        <th>Sq Ft</th>
                        <th>Type</th>
                        <th className="text-end">Price per SqFt</th>
                        <th className="text-end">Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {priceBrackets.map(bracket => {
                        return (
                        <tr>
                            <td>{bracket.minimumSquareFeet} - {bracket.maximumSquareFeet}</td>
                            <td>{bracket.propertyType}</td>
                            <td className="text-end">${bracket.pricePerSquareFoot}</td>
                            <td className="text-end">
                                <Dropdown style={{display: 'flex', justifyContent: 'flex-end'}} align="end"
                                          className="text-end">
                                    <Dropdown.Toggle as={CustomToggle} id="priceSqFtBtn">
                                        <i className="fa-solid fa-ellipsis"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => {
                                                setActiveModalData(bracket);
                                                setShowModal(true);
                                            }}
                                        >
                                            <i className="fa-light fa-pencil fa-fw"></i> Edit
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            className={'text-danger'}
                                            onClick={() => {
                                                setShowDeleteModal(true);
                                                setDeleteRecordData(bracket.priceBracketId)
                                            }}
                                        >
                                            <i className="fa-light fa-trash  fa-fw"></i> Delete
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>
        </div>
        <PricePerSqFtModal show={showModal} toggle={() => setShowModal(false)} details={activeModalData} year={details.year}/>
        <ConfirmationModal show={showDeleteModal} toggle={() => setShowDeleteModal(false)} onConfirm={deleteRecord}/>
    </>);
};

export default PricePerSqFtCard;
function setPriceBracket(res: any) {
    throw new Error('Function not implemented.');
}

